import React from 'react';

import { ChatSourceProvider } from '~/components/AiChat/contexts/ChatSourceContext';
import { SIDEBAR_DIALOG_CONFIG } from '~/components/AiChat/SideBarDialog/SidebarDialogConstants';
import { CLIVE_GRADIENTS } from '~/components/Clive/cliveRegistry';
import cn from '~/Utils/cn';

import { EmbeddedChatContent } from './EmbeddedChatContent';
import { EmbeddedChatProvider } from './EmbeddedChatContext';
import { EmbeddedChatHeader } from './EmbeddedChatHeader';

interface EmbeddedChatProps {
  onClose: () => void;
}

export const EmbeddedChat: React.FC<EmbeddedChatProps> = ({ onClose }) => (
  <ChatSourceProvider source="embedded">
    <EmbeddedChatProvider>
      <div className={cn(SIDEBAR_DIALOG_CONFIG.dialogClassName, CLIVE_GRADIENTS.page)} aria-label="Clive AI Assistant">
        <EmbeddedChatHeader onClose={onClose} />
        <EmbeddedChatContent />
      </div>
    </EmbeddedChatProvider>
  </ChatSourceProvider>
);
